import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import ApproveBeneficiaryComponent from './ApproveBeneficiaryComponent';
import Header from './components/header/Header';
import useApproveBeneficiary from './hooks/useApproveBeneficiary';
import { ActionType, UpdateBeneficiaryServiceResponse } from './types';

const ApproveBeneficiary = ({
  showRemainingTime = false,
  beneficiaryData,
}: {
  showRemainingTime?: boolean;
  beneficiaryData?: UpdateBeneficiaryServiceResponse;
}) => {
  const [searchParams] = useSearchParams();
  const { data, updateBeneficiary, error } = useApproveBeneficiary();

  const token = searchParams.get('token');
  const action = searchParams.get('action');

  useEffect(() => {
    if (token && action && action !== 'pending' && !showRemainingTime) {
      updateBeneficiary({ token, action: action as ActionType });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, action]);

  return (
    <Box sx={{ padding: '1rem', minHeight: '100vh' }}>
      <Header />
      <ApproveBeneficiaryComponent
        action={action as ActionType}
        showRemainingTime={showRemainingTime}
        error={!!error}
        beneficiaryData={beneficiaryData || data}
      />
    </Box>
  );
};

export default ApproveBeneficiary;
